export default "ui-definition-list:not([layout]){display:flex;flex-direction:column;gap:var(--ui-spacing-xlarge)}\n";